import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Grid,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSetSnackBar } from '../../../store/Snackbar.state';
import { Loading } from '../../atoms';
import { useAddTaxRate, AddTaxRateRequest } from '../../../hooks';

function AddTaxRate() {
  const navigate = useNavigate();
  const setSnackbar = useSetSnackBar();
  const { mutate: addTaxRate, isLoading: isAddLoading } = useAddTaxRate();

  const [formData, setFormData] = useState<AddTaxRateRequest>({
    id: 0,
    name: '',
    tax: 0,
  });

  const [taxInputValue, setTaxInputValue] = useState('');

  const [error, setError] = useState('');
  const isLoading = isAddLoading;

  const handleInputChange = (field: keyof AddTaxRateRequest) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (field === 'tax') {
      const inputValue = event.target.value;
      setTaxInputValue(inputValue);

      const numericValue = inputValue === '' ? 0 : parseFloat(inputValue);
      setFormData(prev => ({
        ...prev,
        tax: isNaN(numericValue) ? 0 : numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: event.target.value
      }));
    }
    setError('');
  };

  const handleSubmit = () => {
    setError('');

    if (!formData.name.trim()) {
      setError('Vergi oranı adı gereklidir');
      return;
    }

    if (formData.tax < 0) {
      setError('Vergi oranı negatif olamaz');
      return;
    }

    addTaxRate(formData, {
      onSuccess: (data: any) => {
        if (data?.isSuccess) {
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message || "Vergi oranı başarıyla eklendi",
          });
          navigate('/vuk-507/tax-rates-listing', { state: { refresh: true } });
        } else {
          setSnackbar({
            severity: "error",
            description: data?.message || "Ekleme sırasında hata oluştu",
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "Ekleme sırasında hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const handleCancel = () => {
    navigate('/vuk-507/tax-rates-listing');
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" component="h1" gutterBottom>
            Yeni Vergi Oranı Ekle
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Vergi Oranı Adı"
                value={formData.name}
                onChange={handleInputChange('name')}
                required
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Vergi Oranı (%)"
                type="number"
                value={taxInputValue}
                onChange={handleInputChange('tax')}
                required
                variant="outlined"
                inputProps={{ min: 0, step: 0.01 }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  İptal
                </Button>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  Kaydet
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default AddTaxRate;
